<template>
	<div class="text-center mt-5">
		Updating thumbnail to programs. It will take sometime.
	</div>
</template>

<script>
	import { mapActions } from 'vuex'

	export default {
	  name: 'google-drive-oauth',
	  async mounted () {
	    let googleOAuthToken = this.$route.query.code
	    await this.afterGoogleDriveOauth(googleOAuthToken)
	  },
	  methods: {
	    ...mapActions([
	      'loadFetchFileFromDriveAndUploadToS3'
	    ]),
	    afterGoogleDriveOauth (googleOAuthToken) {
      if (googleOAuthToken === 'access_denied') {
        window.close()
      }
      this.loadFetchFileFromDriveAndUploadToS3(googleOAuthToken)
    }
	  }
	}
</script>


// WEBPACK FOOTER //
// src/app/programguide/components/GoogleDriveOauth.vue